import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { textMega, hideVisually, disableVisually } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  ${textMega({ theme })};
  display: block;
`;

const visuallyHiddenStyles = ({ visuallyHidden }) =>
  visuallyHidden &&
  css`
    ${hideVisually()};
  `;

const inlineStyles = ({ theme, inline }) =>
  inline &&
  css`
    display: inline-block;
    margin-right: ${theme.spacings.mega};
  `;

const disabledStyles = ({ disabled }) =>
  disabled &&
  css`
    ${disableVisually()};
  `;

const Label = styled('label')(baseStyles, visuallyHiddenStyles, inlineStyles, disabledStyles);

Label.propTypes = {
  htmlFor: PropTypes.string,
  visuallyHidden: PropTypes.bool,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Label;
